'use client';

import { customerApi, type Customer } from '@/app/(modules)/robot-manager/_lib/api';
import { Badge } from '@/app/(modules)/robot-manager/_lib/SimpleListPage';
import { CrudListPage } from '@/app/(modules)/robot-manager/_lib/CrudListPage';

import { countryToCurrency } from '@/lib/country-currency';

export default function CustomersAdminPage() {
  return (
    <CrudListPage<Customer>
      title="客户"
      description="跨模块复用的客户主数据"
      api={customerApi}
      searchPlaceholder="搜索客户 code / name"
      draftKey="platform-master:customer"
      inlineEditFields={['enabled']}
      formFields={[
        {
          key: 'code',
          label: '编码',
          type: 'text',
          placeholder: '留空自动生成（C-时间戳）',
          createOnly: true,
          validate: (v) => (v && String(v).length < 3 ? '至少 3 位' : null),
        },
        { key: 'name', label: '名称', type: 'text', required: true },
        {
          key: 'type',
          label: '类型',
          type: 'select',
          required: true,
          defaultValue: 'B2B',
          options: [
            { value: 'B2B', label: 'B2B 企业客户' },
            { value: 'B2C', label: 'B2C 个人' },
            { value: 'INTERNAL', label: '内部' },
          ],
        },
        { key: 'industry', label: '行业', type: 'text' },
        {
          key: 'countryCode',
          label: '国家代码 (CN/US/...)',
          type: 'text',
          placeholder: 'ISO-2 字母代码',
          validate: (v) =>
            v && !/^[A-Z]{2}$/.test(String(v).toUpperCase()) ? '应为 2 位字母（如 CN）' : null,
        },
        {
          key: 'currencyCode',
          label: '默认币种 (USD/CNY/...)',
          type: 'text',
          placeholder: '从国家自动推断',
          derive: (all) => countryToCurrency(all.countryCode),
        },
        { key: 'taxId', label: '税号', type: 'text' },
        { key: 'creditLimit', label: '信用额度', type: 'number' },
        { key: 'enabled', label: '启用', type: 'boolean', defaultValue: true },
      ]}
      columns={[
        { key: 'code', label: '编码', width: '160px' },
        { key: 'name', label: '名称' },
        { key: 'type', label: '类型', width: '100px', render: (c) => <Badge text={c.type} /> },
        { key: 'industry', label: '行业', width: '120px' },
        { key: 'countryCode', label: '国家', width: '80px' },
        { key: 'currencyCode', label: '币种', width: '80px' },
        { key: 'enabled', label: '启用', width: '80px', render: (c) => (c.enabled ? '✓' : '✗') },
      ]}
    />
  );
}
